import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import {
  Container,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
  Modal,
} from "reactstrap"
import { Link } from "react-router-dom"

import BootstrapTable from "react-bootstrap-table-next"
import filterFactory, { textFilter } from "react-bootstrap-table2-filter"
import paginationFactory from "react-bootstrap-table2-paginator"

import { get, post } from "../../helpers/api_helper"
import * as url from "../../helpers/url_helper"
import cogoToast from "cogo-toast"

import moment from "moment"

const Task = props => {
  const [loading, setLoading] = React.useState(true)
  const [errors, setErrors] = React.useState([])
  const [editing, setEditing] = React.useState(false)
  const [data, setData] = React.useState(null)
  const [origData, setOrigData] = React.useState(null)

  const [workorderId, setWorkorderId] = React.useState(null)

  const fetchData = () => {
    setLoading(true)
    get(
      (props.mode == "ppm" ? url.GET_PPM_TASK : url.GET_TASK) + "/" + props.id
    )
      .then(response => {
        console.log("RESP", response.data)
        if (response.status == 200) {
          let resData = response.data
          if (resData.ppmchecklist) {
            resData.ppmchecklist.data = JSON.parse(resData.ppmchecklist.data)
          }
          if (resData.checklist) {
            resData.checklist.data = JSON.parse(resData.checklist.data)
          }
          setData(resData)
          setOrigData(resData)
          setLoading(false)
        } else {
          setData(null)
          setLoading(false)
        }
      })
      .catch(error => {
        console.log("err:", error)
      })
  }

  React.useEffect(() => {
    fetchData()
  }, [])

  // console.log(data);

  const handleSubmit = () => {
    // console.log('data', data);

    // TODO : Validations / epmty checks / mandatory fields

    // if(!frequencies[i].assets || frequencies[i].assets.length < 1) {
    //   cogoToast.error('Please choose assets for frequency '+(i+1));
    //   return;
    // }

    let formData = {
      id: props.mode == "ppm" ? data.ppmchecklist.id : data.checklist.id,
      data:
        props.mode == "ppm"
          ? JSON.stringify(data.ppmchecklist.data)
          : JSON.stringify(data.checklist.data),
      mode: props.mode,
      remarks: data.remarks,
    }

    console.log("data", formData)

    setLoading(true)
    setErrors([])
    post(url.POST_EDIT_CHECKLIST, formData).then(
      response => {
        console.log("RESP", response)
        if (response.status == 200) {
          cogoToast.success("Checklist updated successfully")
          setEditing(false)
          fetchData()
        } else if (response.status == 400) {
          // setErrors(Object.values(response.error));
        } else {
          console.log("err::", response)
        }
      },
      error => {
        console.log(error)
        setLoading(false)
      }
    )
  }

  return (
    <Modal
      isOpen={true}
      size="xl"
      toggle={() => {
        // tog_scroll()
      }}
      scrollable={true}
    >
      {workorderId && (
        <div className="workorderOverlay">
          <div className="pt-4 px-3 d-flex flex-row justify-content-between w100">
            <h3>Work order details</h3>
            <div className="d-flex flex-row">
              <a
                className="btn btn-primary"
                href={
                  "https://apilogbook.six30labs.com/workorder/pdf/" + data.id
                }
                target="_blank"
              >
                Download
              </a>
              <button
                type="button"
                className="btn btn-light ms-2"
                onClick={() => {
                  setWorkorderId(null)
                }}
              >
                Close
              </button>
            </div>
          </div>

          <div className="workorderBody">
            <h4 className="mb-3">Asset details</h4>
            <div className="w100 d-flex flex-row">
              <div className="flex-1 d-flex flex-row border-main">
                <div className="flex-2 border-sub">
                  <p className="fw-medium m-0 py-2 ps-3">Asset type</p>
                </div>
                <div className="flex-3 border-sub">
                  <p className="m-0 py-2 ps-3">{data.asset.assettype?.name}</p>
                </div>
              </div>
              <div className="flex-1 d-flex flex-row border-main">
                <div className="flex-2 border-sub">
                  <p className="fw-medium m-0 py-2 ps-3">Asset location</p>
                </div>
                <div className="flex-3 border-sub">
                  <p className="m-0 py-2 ps-3">
                    {data.asset.property?.name} / {data.asset.block?.name} /{" "}
                    {data.asset.building?.name}
                  </p>
                </div>
              </div>
            </div>
            <div className="w100 d-flex flex-row">
              <div className="flex-1 d-flex flex-row border-main">
                <div className="flex-2 border-sub">
                  <p className="fw-medium m-0 py-2 ps-3">Asset name</p>
                </div>
                <div className="flex-3 border-sub">
                  <p className="m-0 py-2 ps-3">{data.asset.name}</p>
                </div>
              </div>
              <div className="flex-1 d-flex flex-row border-main">
                <div className="flex-2 border-sub">
                  <p className="fw-medium m-0 py-2 ps-3">Room</p>
                </div>
                <div className="flex-3 border-sub">
                  <p className="m-0 py-2 ps-3">{data.asset.room?.name} </p>
                </div>
              </div>
            </div>
            <div className="w100 d-flex flex-row">
              <div className="flex-1 d-flex flex-row border-main">
                <div className="flex-2 border-sub">
                  <p className="fw-medium m-0 py-2 ps-3">Asset code</p>
                </div>
                <div className="flex-3 border-sub">
                  <p className="m-0 py-2 ps-3">{data.asset.asset_code} </p>
                </div>
              </div>
              <div className="flex-1 d-flex flex-row border-main">
                <div className="flex-2 border-sub">
                  <p className="fw-medium m-0 py-2 ps-3">Floor</p>
                </div>
                <div className="flex-3 border-sub">
                  <p className="m-0 py-2 ps-3">{data.asset.floor?.name} </p>
                </div>
              </div>
            </div>

            <h4 className="mt-5 mb-2">Activity details</h4>
            <div className="w100 d-flex flex-row mt-3">
              <div className="flex-1 d-flex flex-row border-main">
                <div className="flex-2 border-sub">
                  <p className="fw-medium m-0 py-2 ps-3">Activity name</p>
                </div>
                <div className="flex-3 border-sub">
                  <p className="m-0 py-2 ps-3">{data.ppmactivity.name}</p>
                </div>
              </div>
              <div className="flex-1 d-flex flex-row border-main">
                <div className="flex-2 border-sub">
                  <p className="fw-medium m-0 py-2 ps-3">Frequency</p>
                </div>
                <div className="flex-3 border-sub">
                  <p className="m-0 py-2 ps-3">{data.ppmactivity.type}</p>
                </div>
              </div>
            </div>
            <div className="w100 d-flex flex-row">
              <div className="flex-1 d-flex flex-row border-main">
                <div className="flex-2 border-sub">
                  <p className="fw-medium m-0 py-2 ps-3">Start date</p>
                </div>
                <div className="flex-3 border-sub">
                  <p className="m-0 py-2 ps-3">{data.start_date}</p>
                </div>
              </div>
              <div className="flex-1 d-flex flex-row border-main">
                <div className="flex-2 border-sub">
                  <p className="fw-medium m-0 py-2 ps-3">End date</p>
                </div>
                <div className="flex-3 border-sub">
                  <p className="m-0 py-2 ps-3">{data.end_date}</p>
                </div>
              </div>
            </div>
            <div className="w100 d-flex flex-row">
              <div className="flex-1 d-flex flex-row border-main">
                <div className="flex-2 border-sub">
                  <p className="fw-medium m-0 py-2 ps-3">Task done at</p>
                </div>
                <div className="flex-3 border-sub">
                  <p className="m-0 py-2 ps-3">{data.ended_at}</p>
                </div>
              </div>
              <div className="flex-1 d-flex flex-row border-main">
                <div className="flex-2 border-sub">
                  <p className="fw-medium m-0 py-2 ps-3">Task done by</p>
                </div>
                <div className="flex-3 border-sub">
                  <p className="m-0 py-2 ps-3">
                    {data.user.name} ({data.user.emp_code})
                  </p>
                </div>
              </div>
            </div>

            <h4 className="mt-5 mb-2">Vendor details</h4>
            <div className="w100 d-flex flex-row mt-3">
              <div className="flex-1 d-flex flex-row border-main">
                <div className="flex-2 border-sub">
                  <p className="fw-medium m-0 py-2 ps-3">Vendor name</p>
                </div>
                <div className="flex-3 border-sub">
                  <p className="m-0 py-2 ps-3">
                    {data.ppmactivity.vendor?.name}
                  </p>
                </div>
              </div>
              <div className="flex-1 d-flex flex-row border-main">
                <div className="flex-2 border-sub">
                  <p className="fw-medium m-0 py-2 ps-3">Contact no.</p>
                </div>
                <div className="flex-3 border-sub">
                  <p className="m-0 py-2 ps-3">
                    {data.ppmactivity.vendor?.phone}
                  </p>
                </div>
              </div>
            </div>

            <h4 className="mt-5 mb-2">Checklist</h4>
            <div className="w100 mt-3 flex-1 d-flex flex-row border-main">
              <div className="flex-1 border-sub">
                <p className="fw-light m-0 py-2 ps-3">Question</p>
              </div>
              <div className="flex-1 border-sub">
                <p className="fw-light m-0 py-2 ps-3">Response</p>
              </div>
            </div>
            {data.ppmchecklist.data.map((dRow, dRowIdx) => (
              <div
                key={dRowIdx}
                className="w100 flex-1 d-flex flex-row border-main"
              >
                <div className="flex-1 border-sub">
                  <p className="m-0 py-2 ps-3">{dRow.label}</p>
                </div>
                <div className="flex-1 border-sub">
                  <p className="m-0 py-2 ps-3">{dRow.val}</p>
                </div>
              </div>
            ))}

            <h4 className="mt-5 mb-2">Attachments</h4>
            {data.ppmchecklist.ppmchecklistimages.length > 0 ? (
              <div className="w100 mt-3 d-flex flex-row flex-wrap justify-content-start align-items-center">
                {data.ppmchecklist?.ppmchecklistimages.map((cImg, cIdx) => (
                  <img
                    key={cIdx}
                    className="checklist-img"
                    src={
                      "https://apilogbook.six30labs.com/storage/checklistimages/" +
                      cImg.filename
                    }
                  />
                ))}
              </div>
            ) : (
              <div className="text-muted pt-1">No images uploaded</div>
            )}

            <h4 className="mt-5 mb-2">Verification</h4>
            {data.ppmchecklist.ppmverifications.length > 0 ? (
              <div>
                <div className="w100 d-flex flex-row mt-3">
                  <div className="flex-1 d-flex flex-row border-main">
                    <div className="flex-2 border-sub">
                      <p className="fw-medium m-0 py-2 ps-3">Date</p>
                    </div>
                    <div className="flex-3 border-sub">
                      <p className="m-0 py-2 ps-3"></p>
                    </div>
                  </div>
                  <div className="flex-1 d-flex flex-row border-main">
                    <div className="flex-2 border-sub">
                      <p className="fw-medium m-0 py-2 ps-3">Comment</p>
                    </div>
                    <div className="flex-3 border-sub">
                      <p className="m-0 py-2 ps-3"></p>
                    </div>
                  </div>
                </div>
                <div className="w100 d-flex flex-row">
                  <div className="flex-1 d-flex flex-row border-main">
                    <div className="flex-2 border-sub">
                      <p className="fw-medium m-0 py-2 ps-3">Verified by</p>
                    </div>
                    <div className="flex-3 border-sub">
                      <p className="m-0 py-2 ps-3"></p>
                    </div>
                  </div>
                  <div className="flex-1 d-flex flex-row border-main">
                    <div className="flex-2 border-sub">
                      <p className="fw-medium m-0 py-2 ps-3">Verified at</p>
                    </div>
                    <div className="flex-3 border-sub">
                      <p className="m-0 py-2 ps-3"></p>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="text-muted pt-1 mb-4">
                No verifications found.
              </div>
            )}
          </div>
        </div>
      )}

      <div className="modal-header">
        <h5 className="modal-title mt-0">
          {props.mode == "ppm" && "PPM "}Task Details
        </h5>
        <button
          type="button"
          onClick={() => {
            props.setTaskId(null)
          }}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        {data == null ? (
          <div className="text-muted">Could not load task details</div>
        ) : (
          <div>
            <div className="row mb-4">
              <div className="col">
                <div className="fw-medium">Activity Name</div>
                <div>
                  {data.asset &&
                    (props.mode == "ppm"
                      ? data.ppmactivity?.name
                      : data.activity?.name)}
                </div>
                {console.log("ppmdetails", data)}
              </div>
              <div className="col">
                <div className="fw-medium">Asset Name</div>
                <div>{data.asset && data.asset.name}</div>
              </div>
              <div className="col">
                <div className="fw-medium">Status</div>
                <div>
                  <span
                    style={{
                      color:
                        data.task_status == "completed"
                          ? "rgb(77, 163, 77)"
                          : data.task_status == "pending"
                          ? "rgb(217, 171, 88)"
                          : data.task_status == "missed"
                          ? "red"
                          : "#222",
                    }}
                  >
                    {data.task_status}
                  </span>
                </div>
              </div>
            </div>
            <div className="row mb-4">
              <div className="col">
                <div className="fw-medium">Scheduled Date</div>
                {props.mode == "ppm" ? (
                  <div>
                    {moment(data.start_date).format("DD MMM YYYY") +
                      " - " +
                      moment(data.end_date).format("DD MMM YYYY")}
                  </div>
                ) : (
                  <div>
                    <div>{data.task_date}</div>
                    <div>
                      {moment(data.start_time, "hh:mm:ss").format("h:mm a")} -{" "}
                      {moment(data.end_time, "hh:mm:ss").format("h:mm a")}
                    </div>
                  </div>
                )}
              </div>
              <div className="col">
                <div className="fw-medium">Done by</div>
                <div>{data.user && data.user.name}</div>
                <div>{data.group && data.group.name}</div>
              </div>
              <div className="col">
                <div className="fw-medium">Done at</div>
                {data.task_status == "completed" ? (
                  <div>
                    <div>
                      {moment(data.started_at).format("YYYY-MM-DD hh:mm a")} to
                    </div>
                    <div>
                      {moment(data.ended_at).format("YYYY-MM-DD hh:mm a")}
                    </div>
                  </div>
                ) : (
                  <div>-</div>
                )}
              </div>
            </div>

            {((props.mode == "ppm" &&
              data &&
              data.ppmchecklist?.ppmchecklistlogs.length > 0) ||
              (props.mode !== "ppm" &&
                data &&
                data.checklist?.checklistlogs.length > 0)) && (
              <div>
                <h5 className="h5 mt-5 mb-3">Edit History</h5>
                <div>
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>User</th>
                        <th>Edited at</th>
                      </tr>
                    </thead>
                    <tbody>
                      {props.mode == "ppm"
                        ? data.ppmchecklist?.ppmchecklistlogs.map(
                            (logItem, logIdx) => (
                              <tr key={logIdx}>
                                <td>Admin</td>
                                <td>
                                  {moment(logItem.created_at).format(
                                    "DD MMM YYYY hh:mm a"
                                  )}
                                </td>
                              </tr>
                            )
                          )
                        : data.checklist?.checklistlogs.map(
                            (logItem, logIdx) => (
                              <tr key={logIdx}>
                                <td>Admin</td>
                                <td>
                                  {moment(logItem.created_at).format(
                                    "DD MMM YYYY hh:mm a"
                                  )}
                                </td>
                              </tr>
                            )
                          )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
            {((props.mode == "ppm" && data && data.ppmchecklist) ||
              (props.mode !== "ppm" && data && data.checklist)) && (
              <div className="mt-3">
                {((props.mode == "ppm" &&
                  data &&
                  data.ppmchecklist?.ppmchecklistimages.length > 0) ||
                  (props.mode !== "ppm" &&
                    data &&
                    data.checklist.checklistimages.length > 0)) && (
                  <div>
                    <h5 className="h5 mt-5 mb-3">Images</h5>
                    <div>
                      {props.mode == "ppm"
                        ? data.ppmchecklist?.ppmchecklistimages.map(
                            (cImg, cIdx) => (
                              <img
                                key={cIdx}
                                className="checklist-img"
                                src={
                                  "https://apilogbook.six30labs.com/storage/checklistimages/" +
                                  cImg.filename
                                }
                              />
                            )
                          )
                        : data.checklist.checklistimages.map((cImg, cIdx) => (
                            <img
                              key={cIdx}
                              className="checklist-img"
                              src={
                                "https://apilogbook.six30labs.com/storage/checklistimages/" +
                                cImg.filename
                              }
                            />
                          ))}
                    </div>
                  </div>
                )}
                <h5 className="h5 mt-5 mb-3">Checklist</h5>
                <div>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Parameter</th>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      {props.mode == "ppm" &&
                        data &&
                        data.ppmchecklist &&
                        data.ppmchecklist.data &&
                        data.ppmchecklist.data.map((citem, citemIdx) => (
                          <tr key={citemIdx}>
                            <td width="50%">
                              <div className="formfield-display">
                                {citem.label}
                              </div>
                            </td>
                            <td width="50%">
                              {editing ? (
                                <div className="formfield-editing">
                                  {citem.type == "number" ? (
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={citem.val}
                                      onChange={e => {
                                        let temp = JSON.parse(
                                          JSON.stringify(data)
                                        )
                                        temp.ppmchecklist.data[citemIdx].val =
                                          e.target.value
                                        setData(temp)
                                      }}
                                    />
                                  ) : citem.type == "radio" ? (
                                    <select
                                      className="form-control"
                                      value={citem.val}
                                      onChange={e => {
                                        let temp = JSON.parse(
                                          JSON.stringify(data)
                                        )
                                        temp.ppmchecklist.data[citemIdx].val =
                                          e.target.value
                                        setData(temp)
                                      }}
                                    >
                                      {citem.options
                                        ?.split(",")
                                        .map((cOpt, cOptIdx) => (
                                          <option key={cOptIdx} val={cOpt}>
                                            {cOpt}
                                          </option>
                                        ))}
                                    </select>
                                  ) : (
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={citem.val}
                                      onChange={e => {
                                        let temp = JSON.parse(
                                          JSON.stringify(data)
                                        )
                                        temp.ppmchecklist.data[citemIdx].val =
                                          e.target.value
                                        setData(temp)
                                      }}
                                    />
                                  )}
                                </div>
                              ) : (
                                <div className="formfield-display">
                                  {citem.val}
                                </div>
                              )}
                            </td>
                          </tr>
                        ))}

                      {props.mode !== "ppm" &&
                        data &&
                        data.checklist &&
                        data.checklist.data.map((citem, citemIdx) => (
                          <tr key={citemIdx}>
                            <td width="50%">
                              <div className="formfield-display">
                                {citem.label}
                              </div>
                            </td>
                            <td width="50%">
                              {editing ? (
                                <div className="formfield-editing">
                                  {citem.type == "number" ? (
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={citem.val}
                                      onChange={e => {
                                        let temp = JSON.parse(
                                          JSON.stringify(data)
                                        )
                                        temp.checklist.data[citemIdx].val =
                                          e.target.value
                                        setData(temp)
                                      }}
                                    />
                                  ) : citem.type == "radio" ? (
                                    <select
                                      className="form-control"
                                      value={citem.val}
                                      onChange={e => {
                                        let temp = JSON.parse(
                                          JSON.stringify(data)
                                        )
                                        temp.checklist.data[citemIdx].val =
                                          e.target.value
                                        setData(temp)
                                      }}
                                    >
                                      {citem.options
                                        ?.split(",")
                                        .map((cOpt, cOptIdx) => (
                                          <option key={cOptIdx} val={cOpt}>
                                            {cOpt}
                                          </option>
                                        ))}
                                    </select>
                                  ) : (
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={citem.val}
                                      onChange={e => {
                                        let temp = JSON.parse(
                                          JSON.stringify(data)
                                        )
                                        temp.checklist.data[citemIdx].val =
                                          e.target.value
                                        setData(temp)
                                      }}
                                    />
                                  )}
                                </div>
                              ) : (
                                <div className="formfield-display">
                                  {citem.val}
                                </div>
                              )}
                            </td>
                          </tr>
                        ))}

                      <tr>
                        <td width="50%">
                          <div className="formfield-display">Remarks</div>
                        </td>
                        <td width="50%">
                          {editing ? (
                            <div className="formfield-editing">
                              {
                                <input
                                  type="text"
                                  className="form-control"
                                  value={data.remarks}
                                  onChange={e => {
                                    let temp = JSON.parse(JSON.stringify(data))
                                    temp.remarks = e.target.value
                                    setData(temp)
                                  }}
                                />
                              }
                            </div>
                          ) : (
                            <div className="formfield-display">
                              {data.remarks}
                            </div>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        )}
        <div className="modal-footer">
          {props.mode == "ppm" && data && data.task_status == "completed" && (
            <button
              type="button"
              className="btn btn-info"
              onClick={() => {
                setWorkorderId(data.id)
              }}
            >
              Work Order
            </button>
          )}
          {editing && (
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => {
                let te = JSON.parse(JSON.stringify(origData))
                setData(te)
              }}
            >
              Reset
            </button>
          )}
          {editing && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                handleSubmit()
              }}
            >
              Submit
            </button>
          )}
          {((props.mode == "ppm" && data && data.ppmchecklist) ||
            (props.mode !== "ppm" && data && data.checklist)) && (
            <button
              type="button"
              className={editing ? "btn btn-secondary" : "btn btn-primary"}
              onClick={() => {
                if (editing) {
                  let te = JSON.parse(JSON.stringify(origData))
                  setData(te)
                }
                setEditing(!editing)
              }}
            >
              {editing ? "Cancel" : "Edit"}
            </button>
          )}

          <Link
            className="btn btn-primary"
            target="_blank"
            to={{
              pathname:
                props.mode == "ppm"
                  ? "/ppmactivities/edit/" + data?.ppmactivity_id
                  : "/activities/edit/" + data?.activity_id,
              query: data?.activity,
            }}
          >
            Edit {props.mode == "ppm" && "PPM "}Activity
          </Link>

          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => {
              props.setTaskId(null)
            }}
          >
            Close
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default Task
